import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import DoubleButton from "components/popup/components/DoubleButton";
import VS from "constants/ValidationShema";
import PropTypes from 'prop-types'
import {createSelectItem} from "components/Select";
import AnnualReportsService from "services/AnnualReportsService";
import isResponseValid from "libs/isResponseValid";
import Typography from "@material-ui/core/Typography";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import {useParams} from "react-router";
import RadioGroup from "components/RadioGroup";
import Loading from "components/Loading";
import {MMiA_REQUIRED_GROUPS} from "constants/EzamowieniaRequiredGroups";

function AddAnnualReportPopup(
    {
        onClose,
        formSubmit,
    }) {

    const params = useParams();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();
    const [working, setWorking] = useState(true);
    const [error, setError] = useState(null);
    const {authorizeEzamowienia} = useEzamowieniaOauth();

    useEffect(() => {
        AnnualReportsService.getAnnualReportListAvailableOrgs(params.year).then(resp => {
            if (isResponseValid(resp, setError)) {
                setItems(resp.result.map(item => createSelectItem(item.orgId, item.name)));
            } else {
                setItems([]);
            }
        }).finally(() => setWorking(false))
    }, [params.year]);

    const [items, setItems] = useState(null);

    const onUpdate = (values) => {
        setError(null);
        setWorking(true);

        authorizeEzamowienia(() => {
            AnnualReportsService.addAnnualReport(values).then((resp) => {
                if (isResponseValid(resp, setError)) {
                    onClose(true);
                } else {
                    setWorking(false);
                }
            }).catch(() => setWorking(false))
        }, () => {
            setWorking(false)
        }, MMiA_REQUIRED_GROUPS)
    }


    return (
        <Dialog
            title={Tr("annual_report_add") + " " + params.year}
            open={true}
            maxWidth={'sm'}
            dialogActions={
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('confirm')}
                    onClickFirst={() => onClose(false)}
                    onClickSecond={handleSubmit}
                    disabledSecond={working || items.length === 0}
                    disabledFirst={working}
                    workingSecond={working || !items}
                />}
        >

            <Form
                initialValues={{
                    year: params.year,
                    orgId: null,
                }}
                validationSchema={Yup.object().shape({
                    orgId: VS.anyRequired()
                })}
                onSubmit={onUpdate}
                id={formId}
            >
                {(formikProps) => (
                    !items ? <Loading/> :
                        <GridBlock column>
                            {!!error && <Typography color='error'>{error}</Typography>}
                            {
                                items.length > 0 &&
                                <RadioGroup
                                    items={items}
                                    formikProps={formikProps}
                                    label={Tr("organizational_unit")}
                                    id="orgId"
                                />

                            }
                        </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

AddAnnualReportPopup.propTypes = {
    onClose: PropTypes.func.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddAnnualReportPopup);